import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRouter, RouterProvider } from '@tanstack/react-router';

import { ErrorPage } from '#/components/ErrorPage.tsx';
import { routeTree } from '#/routeTree.gen.ts';

const queryClient = new QueryClient();

const router = createRouter({ routeTree, defaultErrorComponent: ErrorPage });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

/**
 * アプリケーションのルートコンポーネント
 * @returns アプリケーションコンポーネント
 */
export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
};
